import { render, staticRenderFns } from "./YjsDocsList.vue?vue&type=template&id=48c47ead"
import script from "./YjsDocsList.vue?vue&type=script&lang=js"
export * from "./YjsDocsList.vue?vue&type=script&lang=js"
import style0 from "./YjsDocsList.vue?vue&type=style&index=0&id=48c47ead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports